import React, { useContext, Fragment } from 'react';
import { Container, Segment, Header, Button, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { RootStoreContext } from '../../app/stores/rootStore';
import LoginForm from '../user/LoginForm';
import RegisterForm from '../user/RegisterForm';

const LoginPage = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, isLoggedIn } = rootStore.userStore;
  const {openModal} = rootStore.modalStore;

  return (
    <Segment inverted textAlign='center' vertical  className='masthead'>
      <Container text style={{ marginTop: '9.2em'}}>
        <Header as='h1' inverted>
          <Image
            src='/assets/Buffalo.png'
            style={{  width: "500px" }}
          />
          </Header>
         {/* <h1> Brighten Technologies </h1>  */}
         <br/>
        
        {isLoggedIn && user ? (
          <Fragment >
            <Header as='h2' inverted content={`Welcome back ${user.displayName}`} />
            {(user.role === 'Member') ? (
            <Button as={Link} to='/employeeportal' size='huge' inverted>
              Go to Field Service Management System!
            </Button>
            ) : (
              <Button as={Link} to='/home' size='huge' inverted>
              Go to Field Service Management System!
            </Button>
            )
            
          }
          </Fragment>
        ) : (
          <Fragment>
          <Header as='h2' inverted content={`Welcome to Field Service Management System`} />
          <Button onClick={() => openModal(<LoginForm />)} size='huge' inverted>
            Login
          </Button>
          <Button onClick={() => openModal(<RegisterForm />)} size='huge' inverted>
            Register
          </Button>
        </Fragment>
        )}
        <div style={{marginTop: "15rem"}}>
        <a href="https://beian.miit.gov.cn" target="_blank" style={{color: "white"}}> 
        ICP备案号：鄂ICP备2021021524号
        </a> 
        </div>
      </Container>
      
    </Segment>
  );
};

export default LoginPage;
